import React, { useEffect, useState } from "react";

import axios from "axios";

import { useDispatch, useSelector } from "react-redux";
import { selectPrefix } from "./../../../utility/Redux/profile";
import { setloading } from "./../../../utility/Redux/modal";
import { useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";
import { SelectDate } from "./../../../utility/Redux/refresh";
import { FormatNumber2 } from "./../../../utility/component/tools";
import { TableRestaurant } from "@mui/icons-material";
import { selectheader } from "./../../../utility/Redux/security";

const Running = () => {
  const location = useLocation();
  const checkDateData = useSelector(SelectDate);
  const [tableReport, setTableReport] = useState([]);

  const navigate = useNavigate();
  const table = useSelector(selectPrefix);
  const dispatch = useDispatch();

  const headers = useSelector(selectheader);

  const getRunningTAbleNo = () => {
    dispatch(setloading(true));
    axios
      .post(
        `/api/salesSubReport/runningTableNo`,
        {
          table_prefix: table,
          from_date: checkDateData,
          to_date: checkDateData,
        },
        {
          headers: headers,
        }
      )
      .then((d) => {
        let data = d.data;
        setTableReport(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(setloading(false));
      });
  };

  useEffect(() => {
    getRunningTAbleNo();
  }, [checkDateData]);

  return (
    <div className="running-tables-grid">
      {tableReport.map((d, index) => {
        return (
          <article className="running-table-card" key={`${d.TCODE}-${index}`}>
            <div className="running-table-topline">
              <span className="running-table-icon"><TableRestaurant /></span>
              <div className="running-table-name"><strong>Table {d.TCODE}</strong><span>{d.TNAME || "Dining area"}</span></div>
              <span className="running-status">Open</span>
            </div>
            <div className="running-table-bottomline">
              <div><span className="running-amount-label">Current bill</span><strong>₹ {FormatNumber2(d.NET_AMT)}</strong></div>
              <div className="running-attendant"><span>Attendant</span><strong>{d.WNAME || "—"}</strong></div>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default Running;
